import api from './api';

export interface Event {
  id: number;
  customer_name: string;
  customer_type?: 'personal' | 'business';
  customer_id?: number | null;
  business_id?: number | null;
  staff_id?: number | null;
  staff?: {
    id: number;
    name: string;
  } | null;
  location?: string;
  type: 'appointment' | 'task' | 'leave';
  all_day: boolean;
  start: string;
  end: string;
  alert: boolean;
  attachment?: string;
  note?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateEventData {
  customer_type?: 'personal' | 'business';
  customer_id?: number | null;
  business_id?: number | null;
  staff_id?: number | null;
  location?: string;
  type: 'appointment' | 'leave';
  all_day?: boolean;
  start: string;
  end: string;
  alert?: boolean;
  attachment?: File;
  note?: string;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const eventService = {
  async getAll(params?: { start?: string; end?: string }) {
    const response = await api.get('/events', { params });
    return response.data;
  },

  async getById(id: number): Promise<Event> {
    const response = await api.get(`/events/${id}`);
    return unwrap<Event>(response);
  },

  async create(data: CreateEventData | FormData): Promise<Event> {
    const response = await api.post('/events', data, {
      headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {},
    });
    return unwrap<Event>(response);
  },

  async update(id: number, data: Partial<CreateEventData> | FormData): Promise<Event> {
    const response = await api.post(`/events/${id}?_method=PUT`, data, {
      headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {},
    });
    return unwrap<Event>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/events/${id}`);
  },
};
